import type { MainTabKey } from '@/sections/poe/types/poe.types';

export function mapToMainTab(
  label: string,
  mainTabKeys: MainTabKey[]
): MainTabKey {
  if (mainTabKeys.length === 0) return 'ATTRIBUTES';
  const lowerLabel = label.toLowerCase();
  let key: MainTabKey = 'ATTRIBUTES';
  if (lowerLabel.includes('request') || lowerLabel.includes('curl'))
    key = 'REQUEST';
  else if (lowerLabel.includes('response')) key = 'RESPONSE';
  else if (
    lowerLabel.includes('detection') ||
    lowerLabel.includes('matcher') ||
    lowerLabel.includes('extracted') ||
    lowerLabel.includes('match') ||
    lowerLabel.includes('template') ||
    lowerLabel.includes('info') ||
    lowerLabel.includes('metadata')
  )
    key = 'DETECTION';
  else if (lowerLabel.includes('attribute')) key = 'ATTRIBUTES';
  // Only return the key if it's present in mainTabKeys, otherwise fallback to 'INFORMATION'
  return mainTabKeys.includes(key) ? key : mainTabKeys[0];
}
